
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/providers",
      function () {
        return require("private-next-pages/app/providers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/providers"])
      });
    }
  